"use strict";

import React from "react";

import Header from "./header.jsx";
import SignUp from "./signup.jsx";

// const store = createStore(VisitApp);

export default class VisitApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = { liked: false };

    // this.componentCleanup = this.componentCleanup.bind(this);
  }

  componentCleanup = (e) => {
    // this will hold the cleanup code
    // whatever you want to do when the component is unmounted or page refreshes
    e.preventDefault();
    localStorage.clear();
  };

  componentDidMount() {
    window.addEventListener("beforeunload", this.componentCleanup);
  }

  componentWillUnmount() {
    this.componentCleanup();
    window.removeEventListener("beforeunload", this.componentCleanup); // remove the event handler for normal unmounting
  }

  render() {
    return (
      <div style={{ backgroundColor: "#3F3F82" }}>
        <Header />
        <SignUp style={{ backgroundColor: "#3F3F82" }} />
      </div>
    );
  }
}
